import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  isDigitalOnboardingStepContentDrivenByLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyContentPicker/SurveyContent';

const styles = () => ({
  root: {
    padding: 0,
    margin: 0,
  },
  form: {
    padding: 0,
  },
});

const SurveyStepForm = ({
  className,
  classes,
  layout,
  metaOverrideSet,
  onSubmitBefore,
  alwaysDisplayErrorMessage,
}) => {
  const { onboardingStepResource } = useSurveyContext();
  const { displayErrorMessage } = useSnackbarContext();
  const isMobile = useMobileLayout();

  const { onboardingStepCollection, isEmbeddedWizard } = useSurveyContext();
  const fieldsToHide = onboardingStepCollection.meta().template().list().map(field => field.attr('name'));
  const isFullWidth = isDigitalOnboardingStepContentDrivenByLayout(onboardingStepResource);

  return (
    <MetaCollectionFormInline
      classes={{
        root: classNames(classes.root, className),
        form: classes.form,
      }}
      collection={onboardingStepCollection}
      metaOverrideSet={metaOverrideSet}
      padding={isFullWidth || isMobile || isEmbeddedWizard ? 'none' : ''}
      FormProps={{
        component: 'div',
        onSubmitBefore,
        layout,
        LayoutProps: {
          excludedFromRemainingFields: fieldsToHide,
          hideErrorList: true,
        },
        readonly: true, // <--- Hides default Submit button
        onFailure: (err) => {
          if (err.status !== 400 || (err.errors.length === 1 && (err.errors[0].source == null || alwaysDisplayErrorMessage))) {
            displayErrorMessage(err, err.errors);
          }
        },
      }}
    />
  );
};

SurveyStepForm.defaultProps = {
  className: '',
  layout: null,
  metaOverrideSet: null,
  onSubmitBefore: null,
  alwaysDisplayErrorMessage: false,
};

SurveyStepForm.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  layout: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  metaOverrideSet: PropTypes.object,
  onSubmitBefore: PropTypes.func,
  alwaysDisplayErrorMessage: PropTypes.bool,
};

export default withStyles(styles)(SurveyStepForm);
